/**
 * iOSの電話番号自動検出を回避するための表示用IDフォーマッタ
 * 見た目は連続した数字, 内部的にはゼロ幅スペースで分断
 */
export const formatDisplayId = (value: string | number, digit: number, chunkSize = 4): string => {
    const padded = value.toString().padStart(digit, '0');

    const regex = new RegExp(`(.{${chunkSize}})`, 'g');
    return padded.replace(regex, `$1\u200B\uFEFF`);
};
